import api from './api';

export interface TelegramLoginData {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: number;
  hash: string;
}

export const authApi = {
  telegramLogin: async (data: TelegramLoginData) => {
    const response = await api.post('/auth/telegram-login', data);
    return response.data;
  },
  verifyRecaptcha: async (token: string, action: string) => {
    const response = await api.post('/auth/verify-recaptcha', { token, action });
    return response.data;
  },
};
